import { Injectable } from '@angular/core';
import { CaseEntityService, ShipmentService } from '../../openapi';
import {
  loadCaseItem,
  loadCaseItemSuccess,
  loadCaseItemFailure,
  loadMyCaseList,
  loadMyCaseListFailure,
  loadMyCaseListSuccess, loadShipmentItem, loadShipmentItemSuccess, loadShipmentItemFailure
} from '../actions/my-cases.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class MyCasesEffects {
  constructor(
    private actions$: Actions,
    private caseService: CaseEntityService,
    private shipmentService: ShipmentService
  ) {
  }

  loadMyCaseList$ = createEffect(() => this.actions$.pipe(
    ofType(loadMyCaseList),
    switchMap(action =>
      this.caseService.getCaseEntityCollectionCaseEntityCollection({
        pagination: false,
        orderCreatedAt: 'desc'
      }).pipe(
        map(cases => loadMyCaseListSuccess({ cases })),
        catchError(() => of(loadMyCaseListFailure()))
      )
    )
  ));

  loadCaseItem$ = createEffect(() => this.actions$.pipe(
    ofType(loadCaseItem),
    switchMap(action =>
      this.caseService.getCaseEntityItemCaseEntityItem({
        id: action.id
      }).pipe(
        map(caseItem => loadCaseItemSuccess({ caseItem })),
        catchError(() => of(loadCaseItemFailure()))
      )
    )
  ));

  loadShipmentItem$ = createEffect(() => this.actions$.pipe(
    ofType(loadShipmentItem),
    switchMap(action =>
      this.shipmentService.getShipmentItemShipmentItem({ id: action.id })
        .pipe(
          map((shipment) => loadShipmentItemSuccess({ shipment })),
          catchError(() => of(loadShipmentItemFailure()))
        )
    )
  ));

}
